import { useEffect, useState } from "react";
import { Images } from "../../Assets/Index";
import { buyTickets, getallTickets } from "../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { setRoomDetail } from "../../Store/B2bslice";
import BetModal from "./BetModal";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";
import ResultModal from "./ResultModal";
import { Avatar, Button, Card, Carousel, Image, Input, Radio, Tag } from "antd";
import { GiModernCity, GiRoad } from "react-icons/gi";
import { RiMenuFold4Fill } from "react-icons/ri";
import { LiaCitySolid } from "react-icons/lia";
import { BsBuildings } from "react-icons/bs";
import { PiCity } from "react-icons/pi";
import { BiPlay, BiUser } from "react-icons/bi";
import { IoMenu } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import {
  MdHelpOutline,
  MdLanguage,
  MdShare,
  MdWarning,
  MdWhatsapp,
} from "react-icons/md";
import { FaEarthAsia, FaLanguage } from "react-icons/fa6";
import { useCommmonStore } from "../../Store/CommonReducer";
import { getProfile } from "../Profile/UserEndpoints";
import { getRoomDetails } from "./HomeApi";

const Home = () => {
  const { profileDetail, setProfileDetail } = useCommmonStore();

  const dispatch = useDispatch();
  const [type, setType] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showResult, setShowResult] = useState({
    show: false,
    num: null,
  });
  const [openBetModal, setOpenBetModal] = useState(false);
  const [data, setData] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [roomSlug, setRoomSlug] = useState("");
  const roomDetail = useSelector((state) => state.colorGame.roomDetail);
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const accessToken = getLocalStorageItem("accessToken");
  const [roomData, setRoomData] = useState([]);
  const contentStyle = {
    height: "25px",
    width: "100px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#face65",
  };
  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 5);

  const formatDate = (date) => date.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formatDate(oneWeekAgo));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [value1, setValue1] = useState("Apple");
  const onChange1 = ({ target: { value } }) => {
    console.log("radio1 checked", value);
    setValue1(value);
  };
  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };
  console.log(roomSlug);
  const GetRoomDetails = (type) => {
    setLoading(true);
    getRoomDetails(`${type}`)
      .then((res) => {
        if (res.status) {
          dispatch(setRoomDetail(res.data));
          navigate("/game/live_game", {
            state: {
              fill: res?.data,
            },
          });
          setRoomData(res.data);
          setTotalPages(res.data.total_pages);
          setTotalItems(res.data.total);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    // GetRoomDetails();
    UserProfile();
  }, [searchTerm, page]);

  const handleLoad = () => {
    setPage((prev) => prev + 1);
  };

  const PurchaseTicket = (val) => {
    const formdata = new FormData();
    formdata.append("ticket_id", val);
    buyTickets(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          // GetAllTickets();
        }
      })
      .catch((err) => console.log(err));
  };

  const menuItems = [
    {
      key: "1",
      icon: <BiUser />,
      label: "Profile",
      title: "Profile",
      onClick: () => {
        // setSelectedMenu("1");
        accessToken ? navigate("/profile") : navigate("/");
      },
    },
    {
      key: "2",
      icon: <MdShare />,
      label: "Share",
      title: "Share",
      onClick: () => {
        // setSelectedMenu("1");
        accessToken ? navigate("/share") : navigate("/");
      },
    },
    {
      key: "3",
      icon: <MdWarning />,
      label: "Disclaimer",
      title: "Disclaimer",
      onClick: () => {
        // setSelectedMenu("1");
        accessToken ? navigate("/disclaimer") : navigate("/");
      },
    },
    {
      key: "4",
      icon: <MdWhatsapp />,
      label: "WhatsApp Support",
      title: "WhatsApp Support",
      onClick: () => {
        accessToken
          ? window.open("https://web.whatsapp.com/", "_blank")
          : navigate("/");
      },
    },
    // {
    //   key: "5",
    //   icon: <MdHelpOutline />,
    //   label: "Call Helpline",
    //   title: "Call Helpline",
    //   // onClick: () => {
    //   //   // setSelectedMenu("1");
    //   //   navigate("/helpline");
    //   // },
    // },
    // {
    //   key: "6",
    //   icon: <FaEarthAsia />,
    //   label: "Website",
    //   title: "Website",
    //   // onClick: () => {
    //   //   // setSelectedMenu("1");
    //   //   navigate("/website");
    //   // },
    // },

    // {
    //   key: "7",
    //   icon: <FaLanguage />,
    //   label: "Change Language",
    //   title: "Change Language",
    //   children: [
    //     {
    //       key: "7-1",
    //       label: "English",
    //       // onClick: () => {
    //       //   navigate("/CabDetails");
    //       // },
    //     },
    //     {
    //       key: "7-2",
    //       label: "Hindi",
    //       // onClick: () => {
    //       //   navigate("/CabDetails");
    //       // },
    //     },
    //   ],
    // },
  ];
  const renderMenuItems = (items) => {
    return (
      <ul className="pl-2  space-y-2">
        <div className="demo-logo-vertical d-flex justify-content-center ">
          <div className="flex justify-center m-5 items-center ">
            <Avatar
              size={64}
              icon={<BiUser />}
              // icon={
              //   <Image
              //     src={profileDetail?.user?.image ?? Images.ProfileImage}
              //     className="bg-none rounded-full"
              //     preview={false}
              //     height={70}
              //     width={100}
              //   />
              // }
              className="border-none bg-[#ba7d13]"
            />
            {/* <Avatar
              size={64}
              icon={<BiUser />}
              className="border-none bg-[#ba7d13]"
            /> */}
          </div>

          <div className="w-full h-12 gap-4 text-white  text-base text-center custome">
            <p>{profileDetail?.user?.name}</p>
            <p>{profileDetail?.user?.mobile}</p>
          </div>
        </div>
        {items.map((item) => (
          <li key={item.key} className="text-white ">
            <div
              className="flex items-center justify-between cursor-pointer hover:text-yellow-400"
              onClick={item.onClick}
            >
              <span className="flex items-center gap-2 mt-6 font-thin custome">
                {item.icon && <span className="text-lg">{item.icon}</span>}
                {item.label}
              </span>
              {item.children && (
                <span className="text-gray-400 text-sm">▶</span>
              )}
            </div>

            {item.children && (
              <div className="ml-4 border-l border-gray-600 pl-2">
                {renderMenuItems(item.children)}
              </div>
            )}
          </li>
        ))}
      </ul>
    );
  };
  console.log(Images.banner1); // Should log a valid image path or URL

  return (
    <>
      {showSidebar && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-10 z-40"
          onClick={() => setShowSidebar(false)}
        />
      )}

      {showSidebar && (
        <div
          className={`fixed top-0 left-100 h-full w-64 bg-[#1f1f1f] z-50 p-4 transform transition-transform duration-300 ${
            showSidebar ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex justify-end mb-4">
            <button onClick={() => setShowSidebar(false)}>
              <IoClose className="text-white w-6 h-6" />
            </button>
          </div>

          <div className="overflow-y-auto h-[calc(100%-60px)] pr-2">
            {renderMenuItems(menuItems)}

            <hr className="my-4 border-gray-600" />

            <ul className="space-y-4 text-white text-base text-center">
              <Button
                type="default"
                className="sm:mt-32 custome rounded-3xl h-10 font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                }}
              >
                LogOut
              </Button>
            </ul>
          </div>
        </div>
      )}

      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#fba037] px-8 py-2 gap-x-3 items-center">
            <div className="text-white font-semibold flex items-center gap-4">
              {accessToken && (
                <IoMenu
                  className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                  onClick={() => setShowSidebar(true)}
                />
              )}
              <p className="text-xl font-normal custome">Chandni Chowk Matka</p>
            </div>
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => navigate("/wallet")}
            >
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>

          <div className="">
            {" "}
            <div className=" m-2 rounded-lg">
              <Card className="bg-black shadow-md border-none shadow-gray-500">
                <div className="flex justify-between items-center">
                  <Card.Meta
                    className="text-white"
                    title={
                      <>
                        <p className="custome text-white">
                          Play Matka on Chandni Chowk Matka app
                        </p>
                      </>
                    }
                    description={
                      <>
                        <p className="custome text-white">
                          Play Matka on Chandni Chowk Matka app and enjoy our services
                        </p>
                      </>
                    }
                  />
                  {/* <div>
                    <a href="tel:+911234567890">
                      <Button
                        className="rounded-full custome border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]
               hover:bg-gradient-to-r hover:from-[#ba7d13] hover:via-[#fba037] hover:to-[#c86d04] text-white"
                      >
                        Call
                      </Button>
                    </a>
                  </div> */}
                </div>
              </Card>
            </div>
            <div className="flex justify-between gap-2 sm:gap-4 m-2 sm:m-4">
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  GetRoomDetails("desaver_number");
                }}
              >
                <Avatar
                  size="large"
                  icon={<GiModernCity />}
                  className="border-none bg-[#3973ac]"
                />
                <span className="mt-2 text-sm text-white custome">Desawar</span>
              </div>
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  GetRoomDetails("gali_number");
                }}
              >
                <Avatar
                  size="large"
                  icon={<GiRoad />}
                  className="border-none bg-pink-800"
                />
                <span className="mt-2 text-sm text-white custome">Gali</span>
              </div>
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  GetRoomDetails("faridabad_number");
                }}
              >
                <Avatar
                  size="large"
                  icon={<BsBuildings />}
                  className=" border-none bg-yellow-500"
                />
                <span className="mt-2 text-sm text-white custome">
                  Faridabad
                </span>
              </div>
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  GetRoomDetails("gaziyabaad_number");
                }}
              >
                <Avatar
                  size="large"
                  icon={<PiCity />}
                  className="border-none bg-[#000099]"
                />
                <span className="mt-2 text-sm text-white custome">
                  Ghaziabad
                </span>
              </div>
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  GetRoomDetails("dubai_diamond_number");
                }}
              >
                <Avatar
                  size="large"
                  icon={<GiModernCity />}
                  className="
                custome border-none bg-[#800080]"
                />
                <span className="mt-2 text-sm text-white">Dubai</span>
              </div>
            </div>
            <div
              className="flex items-center overflow-hidden justify-center m-6 rounded-lg shadow-md border-none shadow-gray-500"
              style={{ height: 200 }}
            >
              {/* <Carousel
                autoplay={true}
                className="shadow-[0px_10px_25px_0px_rgba(0,0,0,0.3)]"
              > */}
              <div>
                <Image
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "contain",
                  }}
                  src={Images.banner2}
                  preview={false}
                />
              </div>
              {/* </Carousel> */}
            </div>
            <div>
              <div className="m-4 bg-black ">
                <p className="text-base text-white custome font-medium ">
                  Live Results
                </p>
                <div
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "desaver_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2  shadow-md border-none shadow-gray-500"
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<LiaCitySolid />}
                      className="border-none bg-pink-600"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Desawar
                    </p>
                    <p className="text-sm text-white custome font-normal ">
                      Winning Number
                    </p>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<LiaCitySolid />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                    />
                  </div>
                </div>
                <div
                  onClick={() => {
                    navigate("/chart/result_data", {
                      state: {
                        slugType: "gali_number",
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                  }}
                  className="cursor-pointer grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2 shadow-md border-none shadow-gray-500"
                >
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size={"large"}
                      icon={<PiCity />}
                      className="border-none bg-green-600"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Gali
                    </p>
                    <p className="text-sm text-white custome font-normal ">
                      Winning Number
                    </p>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<LiaCitySolid />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                    />
                  </div>
                </div>
              </div>
              <div className="m-4 bg-black ">
                <p className="text-base text-white custome font-medium ">
                  Live Games
                </p>
                <div className="grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2  shadow-md border-none shadow-gray-500">
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<GiModernCity />}
                      className="border-none bg-blue-900 "
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Gali
                    </p>
                    <p className="text-xs text-white custome font-normal">
                      {/* 24236 people are playing */}
                    </p>
                    <Tag className="text-xs text-white bg-green-600 border-none px-1 custome font-normal">
                      Game Open
                    </Tag>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="default"
                      icon={<BiPlay />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                      onClick={() => {
                        GetRoomDetails("gali_number");
                      }}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2  shadow-md border-none shadow-gray-500">
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<LiaCitySolid />}
                      className="border-none bg-pink-900"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Delhi City
                    </p>
                    <p className="text-xs text-white custome font-normal">
                      {/* 24236 people are playing */}
                    </p>
                    <Tag className="text-xs text-white bg-green-600 border-none px-1 custome font-normal">
                      Game Open
                    </Tag>
                  </div>
                  <div className="cursor-pointer">
                    <Avatar
                      size="default"
                      icon={<BiPlay />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                      onClick={() => {
                        GetRoomDetails("delhi_city_number");
                      }}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2  shadow-md border-none shadow-gray-500">
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<GiRoad />}
                      className="border-none bg-[#600080]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Faridabad
                    </p>
                    <p className="text-xs text-white custome font-normal">
                      {/* 24236 people are playing */}
                    </p>
                    <Tag className="text-xs text-white bg-green-600 border-none px-1 custome font-normal">
                      Game Open
                    </Tag>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="default"
                      icon={<BiPlay />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                      onClick={() => {
                        GetRoomDetails("faridabad_number");
                      }}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2 shadow-md border-none shadow-gray-500">
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<BsBuildings />}
                      className="border-none bg-[#996633]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Ghaziabad
                    </p>
                    <p className="text-xs text-white custome font-normal">
                      {/* 24236 people are playing */}
                    </p>
                    <Tag className="text-xs text-white bg-green-600 border-none px-1 custome font-normal">
                      Game Open
                    </Tag>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="default"
                      icon={<BiPlay />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                      onClick={() => {
                        GetRoomDetails("gaziyabaad_number");
                      }}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2 shadow-md border-none shadow-gray-500">
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<GiModernCity />}
                      className="border-none bg-[#800080]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Dubai Diamond
                    </p>
                    <p className="text-xs text-white custome font-normal">
                      {/* 24236 people are playing */}
                    </p>
                    <Tag className="text-xs text-white bg-green-600 border-none px-1 custome font-normal">
                      Game Open
                    </Tag>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="default"
                      icon={<BiPlay />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                      onClick={() => {
                        GetRoomDetails("dubai_diamond_number");
                      }}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-[30%_50%_20%] gap-2 items-center rounded-lg mt-2 shadow-md border-none shadow-gray-500">
                  <div className="text-center cursor-pointer">
                    <Avatar
                      size="large"
                      icon={<BsBuildings />}
                      className="border-none bg-[#3973ac]"
                    />
                  </div>
                  <div className="shadow-sm m-2">
                    <p className="text-base text-white custome font-medium ">
                      Desawar
                    </p>
                    <p className="text-xs text-white custome font-normal">
                      {/* 24236 people are playing */}
                    </p>
                    <Tag className="text-xs text-white bg-green-600 border-none px-1 custome font-normal">
                      Game Open
                    </Tag>
                  </div>
                  <div className=" cursor-pointer">
                    <Avatar
                      size="default"
                      icon={<BiPlay />}
                      className="border-none bg-gradient-to-r from-[#c86d04] via-[#ba7d13] to-[#fba037]"
                      onClick={() => {
                        GetRoomDetails("desaver_number");
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="m-4 bg-black ">
                <p className="text-base text-white custome font-medium ">
                  Upcoming Games
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 items-center rounded-lg mt-2  ">
                  <div className="shadow-md border-none shadow-gray-500 m-2 p-4">
                    <Avatar
                      size="large"
                      icon={<LiaCitySolid />}
                      className="border-none text-center bg-yellow-500"
                    />
                    <p className="text-base text-white custome font-medium mt-4 mb-4">
                      Desawar
                    </p>
                    <p className="text-xs text-white custome font-normal mb-1">
                      Start Time : 05:00am
                    </p>
                    <p className="text-xs text-white custome font-normal mb-1">
                      End Time : 05:30am
                    </p>
                    <p className="text-xs text-white custome font-normal ">
                      Result Time : 05:00pm
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {openBetModal && (
        <BetModal
          isOpen={openBetModal}
          type={type}
          setIsOpen={setOpenBetModal}
          data={data}
        />
      )}
      {showResult.show && (
        <ResultModal
          open={showResult.show}
          setIsOpen={setShowResult}
          num={showResult.num}
        />
      )}
    </>
  );
};

export default Home;
